import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { EntityListComponent } from './entity-list/entity-list.component';
import { EntityDetailComponent } from './entity-detail/entity-detail.component';
import { EntityDialogComponent } from './entity-dialog/entity-dialog.component';

@NgModule({
  declarations: [
    EntityListComponent,
    EntityDetailComponent,
    EntityDialogComponent
  ],
  imports: [
    SharedModule
  ]
})
export class EntitiesModule { }
